export default __webpack_public_path__ + "static/media/(68).b1dc08a8.jpg";